type OptionsProps = {
  separator?: string
  format?: string
}

const options: OptionsProps = {
  separator: '/',
  format: 'dd/mm/yyyy',
}

export const getFormattedDate = (
  date: string,
  obj = options
  // switchDDMM?: boolean
) => {
  const { separator = '/', format = 'dd/mm/yyyy' } = obj

  const created = new Date(date)
  const dd = String(created.getDate()).padStart(2, '00')
  const mm = String(created.getMonth() + 1).padStart(2, '00')
  const yyyy = created.getFullYear()

  const formats = {
    'dd/mm/yyyy': [dd, mm, yyyy],
    'yyyy/mm/dd': [yyyy, mm, dd],
    'mm/yyyy': [mm, yyyy],
  }

  return formats[format].join(separator)
}

export const checkDateFormat = (date: string) => {
  // check if a sting in format DD/MM/YYYY
  const regex =
    /^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d$/

  return regex.test(date)
}

export const transformToISOdate = (dateString: string) => {
  // DD/MM/YYYY
  // // expected output: 2011-10-05T14:48:00.000Z
  const newDate = dateString.replace(/(\d+[/])(\d+[/])/, '$2$1')
  const event = new Date(newDate)
  return event.toISOString()
}

export const fromDDMMStringToData = (str: string) => {
  if (checkDateFormat(str)) {
    const [day, month, year] = str.split('/')
    const date = new Date(+year, parseInt(month) - 1, +day)
    return date // 👉️ Fri Apr 22 2022
  }
  return null
}

export const fromISOToDateString = (str: string) => {
  const date = new Date(str)
  return date.toLocaleDateString('en-us', {
    // weekday: 'long',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }) // // 👉️ Aug 11, 2022
}

// https://www.freecodecamp.org/news/how-to-format-dates-in-javascript/
// toString() => Fri Jul 02 2021 14:03:54 GMT+0100 (British Summer Time)
// toDateString() => Fri Jul 02 2021
// toLocaleString() => 2/7/2021, 2:03:54 PM
// toLocaleDateString() => 2/7/2021
// toLocaleTimeString() => 2:03:54 PM
// toISOString() => 2021-07-02T13:03:54.000Z
